import { render, staticRenderFns } from "./LinhaProduto.vue?vue&type=template&id=1739ebc5&scoped=true"
import script from "./LinhaProduto.vue?vue&type=script&lang=js"
export * from "./LinhaProduto.vue?vue&type=script&lang=js"
import style0 from "./LinhaProduto.vue?vue&type=style&index=0&id=1739ebc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739ebc5",
  null
  
)

export default component.exports